var LOGIC=LOGIC||{};LOGIC.boltCircle=(function(){/**
 * Bolt circle (PCD) maths + the DRO move timeline used by screens/bolt-circle.html.
 * Angles are degrees, counter-clockwise from +X (3 o'clock). Hole 1 sits at the start angle.
 * Coordinates are from the bore centre (X0 Y0), +Y up — same as a mill DRO zeroed on the centre.
 */

function boltCircleHoles(n, pcd, startDeg = 0) {
  const r = pcd / 2, holes = [];
  for (let k = 0; k < n; k++) {
    const a = startDeg + (k * 360) / n, rad = (a * Math.PI) / 180;
    holes.push({ index: k + 1, angleDeg: a, x: clean(r * Math.cos(rad)), y: clean(r * Math.sin(rad)) });
  }
  return holes;
}

/** Straight-line distance between neighbouring holes. */
const pitch = (n, pcd) => pcd * Math.sin(Math.PI / n);

/** Angle between holes. */
const angleApart = (n) => 360 / n;

/**
 * DRO readings for a position.
 * ABS: from the bore centre. INC: from the hole you just left (zero both axes there).
 */
function droReading(pos, mode = 'abs', ref = { x: 0, y: 0 }) {
  return mode === 'inc' ? { x: clean(pos.x - ref.x), y: clean(pos.y - ref.y) } : { x: clean(pos.x), y: clean(pos.y) };
}

/** Animation timings (ms). */
const TIMING = { axisMs: 780, drillMs: 900, bootDelayMs: 700 };

const easeInOutCubic = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);

/**
 * Spindle position t ms into a move. The table moves X first, then Y — like winding one handwheel then the other.
 * An axis that doesn't need to move takes 0 ms. Returns { x, y, axis: 'x' | 'y' | null, done }.
 */
function moveFrame(from, to, t, axisMs = TIMING.axisMs) {
  const tx = Math.abs(to.x - from.x) > 0.0005 ? axisMs : 0, ty = Math.abs(to.y - from.y) > 0.0005 ? axisMs : 0;
  if (t < tx) { const e = easeInOutCubic(t / tx); return { x: from.x + (to.x - from.x) * e, y: from.y, axis: 'x', done: false }; }
  if (t < tx + ty) { const e = easeInOutCubic((t - tx) / ty); return { x: to.x, y: from.y + (to.y - from.y) * e, axis: 'y', done: false }; }
  return { x: to.x, y: to.y, axis: null, done: true };
}

/** Next hole that still needs drilling, searching forward from `after`. -1 when all are drilled. */
function nextUndrilled(n, drilled, after) {
  for (let i = 1; i <= n; i++) { const j = (after + i) % n; if (!drilled[j]) return j; }
  return -1;
}

/** Rounds away float dust so -0.000 never shows. */
function clean(v) { return Math.abs(v) < 0.0005 ? 0 : Math.round(v * 1e6) / 1e6; }
return {boltCircleHoles,pitch,angleApart,droReading,TIMING,moveFrame,nextUndrilled}})();
